module.exports = __webpack_public_path__ + "static/media/35.8ee5a190.jpg";